import { Accordion } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SelectBox from "elements/SelectBox";
import InputBox from "elements/InputBox";
import Pagination from "elements/Pagination";
import DateSelector from "elements/DateSelector";
import NoRecordsFound from "elements/NoRecordsFound";
import CategoryGames from "elements/gameElements/CategoryGames";
import GameItem from "elements/gameElements/GameItem";
import api from "services/api";
import Translator, { __ } from "services/Translator";
import PageHeadline from "../PageHeadline";
import useShowUnavailable from "hooks/useShowUnavailable";
import { filterGamesForDisplay } from "services/gameAvailability";

export default function FavoriteGames(props) {
  const defaultForm = {
    page: 1,
    triggerSearch: true,
  };
  const [results, setResults] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [pagination, setPagination] = useState([]);
  // No toggle UI on this tab (no sort header); it honours the shared session
  // value. Greying/unlaunchable treatment comes free from GameItem.
  const [showUnavailable] = useShowUnavailable();
  const updateForm = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const getResults = async () => {
    props.setSpinner(true);
    var response = await api.post("/games/favorites", form);
    props.setSpinner(false);
    if (response.status === 200) {
      setResults(response.data.data);
      setPagination(response.data.paginationData);
    } else {
      props.showAlert(null, response.data.message, true);
    }
    updateForm(false, "triggerSearch"); //Ready for next trigger
  };

  useEffect(() => {
    if (form.triggerSearch) {
      getResults();
    }
  }, [form.triggerSearch]);

  const onPageChange = (page) => {
    setForm({ ...form, page: page, triggerSearch: true });
  };

  const visibleResults = filterGamesForDisplay(results, showUnavailable);

  return (
    <>
      <PageHeadline page_name={__("My Games")} />

      <div className="page_content_area">
        <div className="d-block ">
          {/* Gated on the FILTERED list: with the toggle OFF and every favourite
              unavailable, testing the raw list would render an empty grid plus a
              Pagination control instead of the no-records state. */}
          {!!visibleResults.length ? (
            <>
              <div className="gamesLists  favorite_games_area">
                {visibleResults.map((game, index) => (
                  <GameItem
                    game={game}
                    isAuthenticated={props.isAuthenticated}
                    landingType={props.landingType}
                    // Stable identity, not the array index: filtering shifts
                    // positions and React would otherwise keep a tile's local
                    // state (favourite heart, image load) on a different game.
                    key={game?.id ?? game?.slug ?? index}
                    props={props}
                  />
                ))}
              </div>

              <br />
              <br />
              <Pagination data={pagination} onPageChange={onPageChange} />
            </>
          ) : (
            <NoRecordsFound
              content={__("Looks like you did not add any favorite games.")}
            />
          )}
        </div>
      </div>
    </>
  );
}
